export default {
  components() {
    return [
      {
        'component': 'search-year',
        label: '연도',
        value: 'year',
        query: {'y': 'year'},
        options: {
          default: new Date().getFullYear(),
        }
      },
      {
        'component': 'search-select',
        label: '반기',
        value: 'half',
        query: {'half': 'select'},
        options: {
          useAll: true,
          items: ['상반기', '하반기'],
          default: '',
        }
      },
      {
        'component': 'search-month',
        label: '월',
        value: 'month',
        query: {'y_m': 'month'},
        options: {
          useAll: true,
          default: '',
          lastLabel: true,
          visibleKeyValue: [
            {'half': ''} // 반기가 '전체'일 때만 표시
          ],
        }
      },
      {
        'component': 'search-disaster-types',
        label: '재해형태',
        value: 'disaster',
        query: {'dty': 'disaster'},
        options: {
        }
      },

      { 'component': 'empty-space' },
      {
        'component': 'search-keyword', label: '부서명', value: 'k1', query: {'k1': 'keyword'}, options: {
          default: '',
        }
      },
      {
        'component': 'search-keyword', label: '팀명', value: 'k2', query: {'k2': 'keyword'}, options: {
          default: '',
        }
      },
      {
        'component': 'search-keyword', label: '구분', value: 'k3', query: {'k3': 'keyword'}, options: {
          default: '',
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({key: 'body.education_date', operator: '>=', value: search.year + '-01-01'})
      conditions.push({key: 'body.education_date', operator: '<=', value: search.year + '-12-31'})
    }

    // 상반기 / 하반기
    if (search.half) {
      if (search.half === '상반기') {
        conditions.push({key: 'body.education_date', operator: '>=', value: search.year + '-01-01'})
        conditions.push({key: 'body.education_date', operator: '<=', value: search.year + '-06-30'})
      }
      else if (search.half === '하반기') {
        conditions.push({key: 'body.education_date', operator: '>=', value: search.year + '-07-01'})
        conditions.push({key: 'body.education_date', operator: '<=', value: search.year + '-12-31'})
      }
      else {
        if (search.month) {
          const month = search.month.toString().padStart(2, '0'); // 1월을 '01'로 변환
          const lastDay = new Date(search.year, parseInt(search.month, 10), 0).getDate();
          conditions.push({key: 'body.education_date', operator: '>=', value: `${search.year}-${month}-01`})
          conditions.push({key: 'body.education_date', operator: '<=', value: `${search.year}-${month}-${lastDay}`})
        }
      }
    } else {
      if (search.month) {
        const month = search.month.toString().padStart(2, '0'); // 1월을 '01'로 변환
        const lastDay = new Date(search.year, parseInt(search.month, 10), 0).getDate();
        conditions.push({key: 'body.education_date', operator: '>=', value: `${search.year}-${month}-01`})
        conditions.push({key: 'body.education_date', operator: '<=', value: `${search.year}-${month}-${lastDay}`})
      }
    }

    // //  교육일
    // if (search.date) {
    //   conditions.push({key: 'body.education_date', operator: '>=', value: search.date.startDate})
    //   conditions.push({key: 'body.education_date', operator: '<=', value: search.date.endDate})
    // }

    //  재해형태
    if (search.disaster) {
      conditions.push({key: 'body.reflected_disaster_type', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    if (search.k1) {
      conditions.push({key: 'body.stdInfo.field_name', operator: 'LIKE', value: `%${search.k1}%`})
    }

    if (search.k2) {
      conditions.push({key: 'body.stdInfo.section', operator: 'LIKE', value: `%${search.k2}%`})
    }

    if (search.k3) {
      conditions.push({key: 'body.education_type.value', operator: 'LIKE', value: `%${search.k3}%`})
    }

    //  검색조건
    const types = {
      '부서명': 'body.stdInfo.field_name',
      '팀명': 'body.stdInfo.section',
      '구분': 'body.education_type.value',
      // '교육일': 'body.education_date',
      '교육 실시 인원': 'body.participants_attended',
    }

    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },

  getHead: () => {
    return [
      { name: "부서명", key: 'body.stdInfo.field_name' },
      { name: "팀명", key: 'body.stdInfo.section' },
      { name: "구분", key: 'body.education_type.value' },
      { name: "재해형태", key: 'body.reflected_disaster_type' },
      { name: "교육 실시 인원", key: 'body.participants_attended' },
      { name: "교육일", key: 'body.education_date' },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 부서명
        case 1:
          return func.getContent(value).stdInfo.section; // 팀명
        case 2:
          return func.getContent(value).education_type; // 교육구분
        case 3:
          return func.getContent(value).reflected_disaster_type.join(", "); // 재해형태
        case 4:
          return func.comma(func.getContent(value).participants_attended); // 교육실시인원
        case 5:
          return func.getContent(value).education_date; // 교육일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
